const MEDInfo = () => {
  return (
    <>
      <p>
        We have developed a special tool for MED9 to patch .bin files directly
        with our custom code for mapswitch and launch control. Check out the
        video above to see how to use the multimap with brake and cruise control
        set.
      </p>
      <p>
        Accelerator and brake pedal works in a similar way. As of now, 2MB and
        2.5MB, MED9.1 - MED9.1.5 are developed fully. Software is well tested
        and all bugs have been removed, and cars have driven more than 10000km
        with multimap code.
      </p>
      <p>
        You need to load stock file of your car with .bin extension. File MUST
        BE stock OBD read or BDM read. VR/virtual read WILL NOT WORK. Pay
        attention to the file you use as no refunds will be given for wrong
        files! The patch has a copy protection code to lock it to 1 car. It will
        work only on the car to which the file belongs.
      </p>
      <p>
        Then you need to input map addresses like KFZW, KFZW2, KFLDRL, KRKATE,
        LAMFA and others when they are added. All addresses should be in
        hexadecimal format (0x, base 16).
      </p>
      <p>
        After you pay, you will be able to download the file from the webpage or
        via email address you provided. We are not responsible for any brick or
        damage to your engine/car/cat/dog, etc! By pressing the "submit" button,
        you agree to the T&amp;Cs listed above.
      </p>
      <p>
        <strong>Pedal Option:</strong>
      </p>
      <ol>
        <li>Press Accelerator pedal 100% and hold</li>
        <li>Brake pedal to switch</li>
      </ol>
      <p>
        <strong>Cruise Option:</strong>
      </p>
      <ol>
        <li>Press brake/clutch pedal and hold it</li>
        <li>Press cruise set to switch maps</li>
      </ol>
    </>
  );
};

export default MEDInfo;
